import { getIncidents } from './incidentsService';

export const analyzeIncidentPatterns = async () => {
  const incidents = await getIncidents();
  
  const analysis = {
    totalIncidents: incidents.length,
    byType: {},
    byClient: {},
    byPriority: {},
    recurringPatterns: [],
    frequentClients: [],
    commonIssues: []
  };
  
  // Аналіз за типами
  incidents.forEach(incident => {
    // По типам
    analysis.byType[incident.type] = (analysis.byType[incident.type] || 0) + 1;
    
    // По клієнтам
    const client = incident.clientName || incident.clientId;
    if (client) {
      analysis.byClient[client] = (analysis.byClient[client] || 0) + 1;
    }
    
    // По пріоритетам
    analysis.byPriority[incident.priority] = (analysis.byPriority[incident.priority] || 0) + 1;
  });
  
  // Виявлення повторюваних патернів
  analysis.recurringPatterns = findRecurringPatterns(incidents);
  analysis.frequentClients = findFrequentClients(analysis.byClient);
  analysis.commonIssues = findCommonIssues(incidents);
  
  return analysis;
};

export const findRecurringPatterns = (incidents) => {
  const patterns = [];
  const last30Days = new Date();
  last30Days.setDate(last30Days.getDate() - 30);
  
  const recentIncidents = incidents.filter(inc => new Date(inc.createdAt) > last30Days);
  
  // Групуємо за типом та клієнтом
  const grouped = {};
  recentIncidents.forEach(incident => {
    const key = `${incident.type}_${incident.clientName || incident.clientId}`;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(incident);
  });
  
  // Знаходимо патерни з більше ніж 2 інцидентами
  Object.keys(grouped).forEach(key => {
    if (grouped[key].length >= 2) {
      const [type, client] = key.split('_');
      patterns.push({
        type,
        client,
        count: grouped[key].length,
        incidents: grouped[key],
        pattern: `Повторюваний ${type} інцидент для ${client}`,
        severity: grouped[key].length >= 3 ? 'high' : 'medium'
      });
    }
  });
  
  return patterns.sort((a, b) => b.count - a.count);
};

export const findFrequentClients = (byClient) => {
  return Object.entries(byClient)
    .filter(([client, count]) => count >= 2)
    .map(([client, count]) => ({ client, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);
};

export const findCommonIssues = (incidents) => {
  const issueKeywords = {
    technical: ['поломка', 'ремонт', 'не працює', 'зламав', 'несправність'],
    client: ['скарга', 'претензія', 'незадоволений', 'проблема', 'не відповідає'],
    logistics: ['доставка', 'затримка', 'транспорт', 'маршрут', 'графік'],
    safety: ['безпека', 'аварія', 'небезпека', 'травма', 'захисний']
  };
  
  const issues = {};
  
  incidents.forEach(incident => {
    const description = incident.description.toLowerCase();
    
    Object.keys(issueKeywords).forEach(type => {
      issueKeywords[type].forEach(keyword => {
        if (description.includes(keyword.toLowerCase())) {
          issues[keyword] = (issues[keyword] || 0) + 1;
        }
      });
    });
  });
  
  return Object.entries(issues)
    .map(([issue, count]) => ({ issue, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);
};

export const getIncidentTrends = async (period = '30d') => {
  const incidents = await getIncidents();
  const now = new Date();
  let startDate;
  
  switch (period) {
    case '7d':
      startDate = new Date(now.setDate(now.getDate() - 7));
      break;
    case '30d':
      startDate = new Date(now.setDate(now.getDate() - 30));
      break;
    case '90d':
      startDate = new Date(now.setDate(now.getDate() - 90));
      break;
    default:
      startDate = new Date(now.setDate(now.getDate() - 30));
  }
  
  const filtered = incidents.filter(inc => new Date(inc.createdAt) >= startDate);
  
  // Групуємо по днях
  const dailyTrends = {};
  filtered.forEach(incident => {
    const date = new Date(incident.createdAt).toISOString().split('T')[0];
    if (!dailyTrends[date]) {
      dailyTrends[date] = {
        date,
        total: 0,
        byType: {},
        byPriority: {}
      };
    }
    
    dailyTrends[date].total++;
    dailyTrends[date].byType[incident.type] = (dailyTrends[date].byType[incident.type] || 0) + 1;
    dailyTrends[date].byPriority[incident.priority] = (dailyTrends[date].byPriority[incident.priority] || 0) + 1;
  });
  
  return Object.values(dailyTrends).sort((a, b) => new Date(a.date) - new Date(b.date));
};